import { createContext } from "react";
import { DocumentViewerContextValue } from "./DocumentViewerContext.types";

export const DocumentViewerContext =
    createContext<DocumentViewerContextValue | null>(null);
